export default __webpack_public_path__ + "static/media/V660MANB5.0b39b132.pdf";